import { FC } from "react";
import { FieldValues, UseFormRegister } from "react-hook-form";

interface Props {
  id: string;
  value?: string;
  register: UseFormRegister<FieldValues>;
}

export const HiddenField: FC<Props> = ({ id, value, register }) => {
  return <input type="hidden" {...register(id)} value={value} />;
};
